// File: cgp-confirmation-dialog.module.ts
// Author: Joseph M Diaz
// Date: 4/28/2017
// Desc: CGP Confirmation Dialog.
// Other Contributors:

import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

import { CgpConfirmationDialogService } from './cgp-confirmation-dialog.service';
import { CgpConfirmationDialogComponent } from './cgp-confirmation-dialog.component';
import { ButtonsModule } from '@progress/kendo-angular-buttons';

@NgModule({
    imports: [
        MatDialogModule, MatButtonModule, ButtonsModule
    ],
    exports: [
        CgpConfirmationDialogComponent
    ],
    declarations: [
        CgpConfirmationDialogComponent
    ],
    providers: [
        CgpConfirmationDialogService
    ]
})
export class CgpConfirmationDialogModule { }
